/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Intro_H3Inputs */

const es_faq_intro_h3 = /** @type {(inputs: Faq_Intro_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es Zarpar?`)
};

const gl_faq_intro_h3 = /** @type {(inputs: Faq_Intro_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que é Zarpar?`)
};

const en_faq_intro_h3 = /** @type {(inputs: Faq_Intro_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Zarpar?`)
};

/**
* | output |
* | --- |
* | "What is Zarpar?" |
*
* @param {Faq_Intro_H3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_intro_h3 = /** @type {((inputs?: Faq_Intro_H3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Intro_H3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_intro_h3(inputs)
	if (locale === "en") return en_faq_intro_h3(inputs)
	return es_faq_intro_h3(inputs)
});